import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "iconsax-reactjs";
import AddCategoryForm from "../../components/partials/add-category/AddCategoryForm";
import type { Category } from "../../services/webServices/category/types";
import { getCategoryById, getCategoriesAll } from "../../services/webServices/category/get";
import { useAdminLoading } from "../../context/AdminLoadingContext";
import { useInitialPageLoad } from "../../components/layouts/admin-layout/useInitialPageLoad";

interface CategoryFormValues {
  id?: number;
  name: string;
  parent?: {
    id: number;
    title: string;
    slug: string;
    depth: number;
    breadcrump?: string;
  } | null;
  link: string;
  description: string;
}

export default function AddCategory() {

  const navigate = useNavigate();
  const { id } = useParams<{ id?: string }>();
  const isEditMode = Boolean(id);

  const [initialValues, setInitialValues] = useState<CategoryFormValues | undefined>(undefined);
  const [categories, setCategories] = useState<Category[]>([]);

  const { showLoading, hideLoading } = useAdminLoading();
  const isFirstLoad = useInitialPageLoad();

  useEffect(() => {
    if (isFirstLoad) showLoading();
    const loadData = async () => {
      const categoriesData = await getCategoriesAll();
      setCategories(categoriesData);

      if (!isEditMode || !id) {
        return;
      }

      const categoryId = Number(id);
      if (Number.isNaN(categoryId)) {
        return;
      }

      const category = await getCategoryById({ id: categoryId });

      setInitialValues({
        id: category?.id,
        name: category?.title || "",
        parent: category?.parent || null,
        link: category?.slug || "",
        description: category?.description || "",
      });

    };

    loadData();
    if (isFirstLoad) hideLoading();
  }, [id, isEditMode]);

  const handleSaved = () => {
    navigate("/category");
  };

  const handleCancel = () => {
    navigate("/category");
  };

  return (
    <div
      className="w-full flex flex-col gap-6 p-4 border rounded-2xl card-shadow bg-white min-h-screen mb-3"
      dir="rtl"
    >
      <div className="flex flex-row items-center px-4 pt-3 justify-between font-medium">
        <h1 className="text-lg font-semibold text-gray-800">
          {isEditMode ? "ویرایش دسته بندی" : "افزودن دسته بندی جدید"}
        </h1>

        <button
          type="button"
          onClick={handleCancel}
          className="flex text-sm font-normal items-center gap-2 bg-transparent text-gray-700 px-4 py-2"
        >
          بازگشت به دسته‌بندی
          <ArrowLeft className="w-5 h-5" />
        </button>
      </div>

      <div className="custom-dashed-border border-gray/50 mt-2" />

      <div className="w-full">
        <AddCategoryForm
          onSaved={handleSaved}
          onCancel={handleCancel}
          categories={categories}
          initialValues={initialValues}
        />
      </div>
    </div>
  );
};